import React, { useRef } from 'react';
import { ENUM_CUS_EVENT, ENUM_PROMO_FILL, ENUM_STRING_MENU, TEST_MODE } from '../../enums/enums';
import {
  setCasinoActions,
  setCasinoList,
  setGroupData,
  setJackpotsByGroupId,
  setNewBonus,
  setPromocodeList,
  setPromocodeSeries
} from '../../store/apps/userSlice';
import { mockCampaignHash } from '../../enums/mock';
import { useAppSelector } from '../../store';
import { useDispatch } from 'react-redux';
import { API_GROUP, API_USER } from '../../api/user';
import { useEventListener } from 'usehooks-ts';
import { setCampaignByGroupId } from '../../store/apps/freeSpinSlice';
import { setRefLinks, setRefLinksInfo } from '../../store/apps/groupInfoSlice';
import { setAddHiddenMenuItems } from '../../store/apps/infoSlice';

// добавить оптимизацию
export default function useEventListeners() {
  const dispatch = useDispatch();
  const userId = useAppSelector((state) => state.user.id);

  const receivingSliderListTmRef = useRef(0);

  const getGroupData = (groupId) => {
    if (!+groupId) return;
    if (!userId) return;
    if (TEST_MODE) {
      return;
    }

    API_USER.group
      .getData(+groupId)
      .then((e) => {
        dispatch(setGroupData({ id: +groupId, data: e.data }));
      })
      .catch(console.error);
  };

  const getBonusList = (groupId) => {
    API_USER.group.bonus
      .list(+groupId)
      .then((e) => {
        const data = e.data.list;
        dispatch(setNewBonus({ id: +groupId, data }));
      })
      .catch(console.error);
  };

  const getPromoList = async ({ groupId, status }, fill) => {
    const promises = [];
    if ([ENUM_PROMO_FILL.all, ENUM_PROMO_FILL.series].includes(fill)) {
      const promiseRes = API_GROUP.bonus.promocode.series
        .list(+groupId)
        .then((e) => {
          const data = e.data.list;
          dispatch(setPromocodeSeries({ id: +groupId, data }));
        })
        .catch(console.error);

      promises.push(promiseRes);
    }

    if ([ENUM_PROMO_FILL.all, ENUM_PROMO_FILL.list].includes(fill)) {
      const promiseRes = API_GROUP.bonus.promocode
        .list(+groupId, status)
        .then((e) => {
          const data = e.data.list;
          dispatch(setPromocodeList({ id: +groupId, data }));
        })
        .catch(console.error);
      promises.push(promiseRes);
    }

    await Promise.all(promises);
  };

  const getJackpots = (groupId) => {
    API_GROUP.bonus.jackpots
      .list({ groupId: +groupId })
      .then((e) => {
        const jackpots = e.data;
        if (!jackpots.list) return;
        dispatch(setJackpotsByGroupId({ id: +groupId, data: jackpots }));
      })
      .catch(console.error);
  };

  const getFreeSpin = (groupId) => {
    if (TEST_MODE) {
      dispatch(setCampaignByGroupId(mockCampaignHash));
      return;
    }

    API_GROUP.bonus.freespin.campaign
      .list({ groupId: +groupId })
      .then((e) => {
        const campaigns = e.data.list;
        if (!campaigns.length) return;
        dispatch(setCampaignByGroupId({ [groupId]: campaigns }));
      })
      .catch(console.error);
  };

  const getRefcodeList = (groupId) => {
    API_GROUP.refCode
      .list({ groupId: +groupId })
      .then((e) => {
        const list = e.data.list;
        const info = e.data.info;
        dispatch(setRefLinks({ groupId, data: list }));
        dispatch(setRefLinksInfo({ groupId, data: info }));
      })
      .catch(console.log);
  };

  const getCasinos = () => {
    API_USER.getList
      .casino()
      .then((e) => {
        dispatch(setCasinoActions(e.data.action));
        dispatch(setCasinoList(e.data.list));
      })
      .catch((e) => {
        const errorCode = e.dataError;
        if (errorCode == 603) {
          dispatch(setAddHiddenMenuItems(ENUM_STRING_MENU.casinoSetting));
          return;
        }

        console.error(e);
      });
  };

  // const debou

  useEventListener(ENUM_CUS_EVENT.getGroupData, (e) => {
    const groupId = e.detail.groupId;
    getGroupData(groupId);
  });

  useEventListener(ENUM_CUS_EVENT.getBonusList, (e) => {
    const groupId = e.detail.groupId;
    getBonusList(groupId);
  });

  useEventListener(ENUM_CUS_EVENT.getFreespinList, (e) => {
    const groupId = e.detail.groupId;
    getFreeSpin(groupId);
  });

  useEventListener(ENUM_CUS_EVENT.getJackpotsList, (e) => {
    const groupId = e.detail.groupId;
    getJackpots(groupId);
  });

  useEventListener(ENUM_CUS_EVENT.getRefcodeList, (e) => {
    const groupId = e.detail.groupId;
    getRefcodeList(groupId);
  });
  useEventListener(ENUM_CUS_EVENT.getCasinos, (e) => {
    getCasinos();
  });

  useEventListener(ENUM_CUS_EVENT.getPromoList, async (e) => {
    const groupId = e.detail.groupId;
    const status = e.detail.status;
    const fill = e.detail.fill || ENUM_PROMO_FILL.all;
    const successFn = e.detail.successFn;

    await getPromoList({ groupId, status }, fill);
    successFn?.();
  });
}
